// extracted by mini-css-extract-plugin
export default {"container":"QuestionErrorMessage__container___kCocL","parentQuestionContainer":"QuestionErrorMessage__parentQuestionContainer___kIoEI","label":"QuestionErrorMessage__label___enHHo"};